import { DEFAULT_QUERY_OPTIONS, useQueryWithBoundary } from '@/shared/lib/query';
import { domainKeys } from '@/shared/lib/query/queryKeys';

import type { DomainListResponse } from '@/entities/domain';

import { getDomainsApi } from '@/features/domain/api';

type UseDomainsParams = {
  limit?: number;
};

export const useDomains = ({ limit = 10000 }: UseDomainsParams = {}) => {
  return useQueryWithBoundary<DomainListResponse>({
    queryKey: domainKeys.lists(limit),
    queryFn: () => getDomainsApi({ limit }),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    ...DEFAULT_QUERY_OPTIONS,
  });
};
